import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { Api } from '../services/api';
import { AuthService } from '../services/auth-service';
import { Login } from '../pages/login/login';



@Component({
  selector: 'app-home',
  standalone: false,
  templateUrl: './home.html',
  styleUrl: './home.scss'
})
export class Home implements OnInit{
  traininCourses: any = {};
  user:any;
  UtypeFlag:boolean = false;
  isLoggedIn:boolean = false;
  @ViewChildren('videoPlayer') videoPlayers!: QueryList<ElementRef<HTMLVideoElement>>;
  @ViewChild('authModal') authModal!: Login;

  constructor(public authService: AuthService, private router: Router,private apiService: Api) { 
    this.authService.isLoggedIn$.subscribe(status => {
      this.isLoggedIn = status;
    });
        const userString = this.authService.getUser();

  if (userString) {
    this.user = typeof userString === 'string'
      ? JSON.parse(userString)
      : userString;

  }
 
    this.getCourses();
  }
  
  ngOnInit(): void {
    if(this.user?.data?.userType === 'USER'){
          this.UtypeFlag = true;
     }
     else{
        this.UtypeFlag = false;
     }
  }
  ngAfterViewInit() {
   setTimeout(() => {
    this.playActiveVideo();
  }, 300);
  }
 playActiveVideo() {
  const videos = this.videoPlayers?.toArray();
  if (!videos || !videos[this.currentSlide]) return;

  const video = videos[this.currentSlide].nativeElement;

  video.muted = true;
  video.currentTime = 0;

  video.play().catch(() => {
    // autoplay blocked – silently ignore
  });
}


  currentSlide = 0;
  slides = [
  
     {
      type: 'video',
      src: 'home.mp4',
      heading: 'Transform Early Childhood Education',
      subheading: 'Master progressive teaching strategies with our 25-hour course.'
    },
  ];

 nextSlide() {
  this.currentSlide = (this.currentSlide + 1) % this.slides.length;
  setTimeout(() => this.playActiveVideo(), 50);
}

prevSlide() {
  this.currentSlide =
    (this.currentSlide - 1 + this.slides.length) % this.slides.length;
  setTimeout(() => this.playActiveVideo(), 50);
}

goToSlide(i: number) {
  this.currentSlide = i;
  setTimeout(() => this.playActiveVideo(), 50);
}


  navgate(courseName: string) {
    this.router.navigate(['/main-course'],{queryParams: {courseName: courseName}})
      .then(success => console.log("Navigation success:", success))
      .catch(err => console.error("Navigation error:", err));
  }

  getCourses() {
    this.apiService.getCourseList().subscribe((result: any)=> {
      this.traininCourses = result?.data[0] || {};
    })
  }

  goToCourses() {
  this.router.navigate(['/'], { fragment: 'video-learning' })
    .then(() => {
      setTimeout(() => {
        document
          .getElementById('video-learning')
          ?.scrollIntoView({ behavior: 'smooth' });
      }, 300);
    });
}

openLoginModal() {
    this.authModal.openModal('login');
  }
   onModalClosed() {
    console.log('Modal was closed');
  }

showAlert(){
  this.apiService.displayToast("Please enroll in the course first.", 500);
}
}
